import { create } from "zustand";
import type { SortField, SortOrder } from "@titancloud/shared";

type ViewMode = "list" | "grid";

interface ExplorerState {
  currentFolderId: string | null;
  selectedIds: Set<string>;
  selectionMode: boolean;
  viewMode: ViewMode;
  sort: SortField;
  order: SortOrder;
  searchQuery: string;

  setCurrentFolder: (id: string | null) => void;
  toggleSelect: (id: string) => void;
  clearSelection: () => void;
  selectAll: (ids: string[]) => void;
  enterSelectionMode: () => void;
  exitSelectionMode: () => void;
  setViewMode: (mode: ViewMode) => void;
  setSort: (sort: SortField, order: SortOrder) => void;
  setSearchQuery: (q: string) => void;
}

export const useExplorerStore = create<ExplorerState>((set) => ({
  currentFolderId: null,
  selectedIds: new Set(),
  selectionMode: false,
  viewMode: "grid",
  sort: "date",
  order: "desc",
  searchQuery: "",

  setCurrentFolder: (id) =>
    set({ currentFolderId: id, selectedIds: new Set(), selectionMode: false, searchQuery: "" }),

  toggleSelect: (id) =>
    set((state) => {
      const next = new Set(state.selectedIds);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return { selectedIds: next };
    }),

  clearSelection: () => set({ selectedIds: new Set() }),

  selectAll: (ids) => set({ selectedIds: new Set(ids) }),

  enterSelectionMode: () => set({ selectionMode: true }),

  exitSelectionMode: () => set({ selectionMode: false, selectedIds: new Set() }),

  setViewMode: (viewMode) => set({ viewMode }),

  setSort: (sort, order) => set({ sort, order }),

  setSearchQuery: (searchQuery) => set({ searchQuery }),
}));
